export enum ResponsiveUIBreakpoints {
    // widths main Menu
    logout = 971,
    settings = 904,
    collapseMarkupTools = 837,
    SearchMenu = 774,
    markupTools = 704,
    speechRecognition = 619,
    referenceTools = 560,
    selectionMode = 560,
    ToolsMenu = 359,

    // heights were measured as K3000 user
    smallMainMenu = 520,
    smallMainMenuLogout = 550,
    smallMainMenuSettings = 580,
    smallMainMenuSpeechRecognition = 610,
    smallMainMenuToolsMenu = 740,

    // special for VERY small screens
    smallMainMenuIconOnly = 440,

    // NOTE:
    // markupTools && ToolsMenu are hardcoded used in layout.component.scss

    // widths main menu for stap add-on license users
    logout_stap_addOn = 1080,
    settings_stap_addOn = 1013,
    examModeSettings = 947,
    collapseMarkupTools_stap_addOn = 890,

}
